import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LockOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { APP_LAYOUT_BASE } from '../../utils/menuPathNormalize';
import './NoAccess.scss';

export const NoAccess: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div className="no-access-page">
      <div className="no-access-card">
        <div className="no-access-icon" aria-hidden="true">
          <LockOutlined />
        </div>
        <h2 className="no-access-title">无权访问</h2>
        <p className="no-access-desc">
          您没有访问此页面的权限，如需开通请联系管理员。
        </p>
        <Button
          type="primary"
          size="large"
          onClick={() => navigate(`${APP_LAYOUT_BASE}/ai-voice`, { replace: true })}
        >
          返回首页
        </Button>
      </div>
    </div>
  );
};

export default NoAccess;